/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DiscountsInputs */

const en_nav_discounts = /** @type {(inputs: Nav_DiscountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discounts`)
};

const es_nav_discounts = /** @type {(inputs: Nav_DiscountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuentos`)
};

/**
* | output |
* | --- |
* | "Discounts" |
*
* @param {Nav_DiscountsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_discounts = /** @type {((inputs?: Nav_DiscountsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DiscountsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_discounts(inputs)
	return es_nav_discounts(inputs)
});